/******************************************************************************
 *** MyInfoDialog ** MY INFO Dialog
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import React from "react";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PersonIcon from '@mui/icons-material/Person';
import FeedbackIcon from '@mui/icons-material/Feedback';
import Util from "@/js/common/Util";
import LabelCheckBox from "@/js/common/ui/input/LabelCheckBox";
import TextBox from "@/js/common/ui/input/TextBox";

interface Props {
    userId: string;
    setMyInfoModalOpen: Function;
    setPswdModalOpen: Function;
}

const MyInfoDialog = ( {userId, setMyInfoModalOpen, setPswdModalOpen}: Props) => {
    const [userNm    , setUserNm    ] = React.useState<string>(""); // 이름
    const [upOgnzNm  , setUpOgnzNm  ] = React.useState<string>(""); // 본부명
    const [ognzNm    , setOgnzNm    ] = React.useState<string>(""); // 지부명
    const [telno     , setTelno     ] = React.useState<string>(""); // 전화번호
    const [jbpsSeNm  , setJbpsSeNm  ] = React.useState<string>(""); // 직위코드
    const [joinSttsCd, setJoinSttsCd] = React.useState<string>(""); // 가입상태코드
    const [joinSttsNm, setJoinSttsNm] = React.useState<string>(""); // 가입상태명
    const [crtDt     , setCrtDt     ] = React.useState<string>(""); // 가입일자
    const [atrzOpnnCn, setAtrzOpnnCn] = React.useState<string>(""); // 결재의견(반려 사유)

    const [auth01Yn, setAuth01Yn] = React.useState<boolean>(false); // 조합비 관리자
    const [auth02Yn, setAuth02Yn] = React.useState<boolean>(false); // 조합비 결재자
    const [auth03Yn, setAuth03Yn] = React.useState<boolean>(false); // 조합비 조회
    const [auth04Yn, setAuth04Yn] = React.useState<boolean>(false); // 조합원 관리자
    const [auth05Yn, setAuth05Yn] = React.useState<boolean>(false); // 조합원 결재자
    const [auth06Yn, setAuth06Yn] = React.useState<boolean>(false); // 조합원 조회
    const [auth07Yn, setAuth07Yn] = React.useState<boolean>(false); // 본부 관리자
    const [auth08Yn, setAuth08Yn] = React.useState<boolean>(false); // 시스템 관리자

    // 회원 상세정보 조회
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url        : "system/mbr/mng/select-mbr-aprv-wtng-dtl.do",
            methodType : "post",
            paramType  : "json",
            paramData  : {
                userId: userId,
            },
            onSuccessFn: (res: any) => {
                setUserNm    (res.result.item.userNm    ); // 이름
                setUpOgnzNm  (res.result.item.upOgnzNm  ); // 본부명
                setOgnzNm    (res.result.item.ognzNm    ); // 지부명
                setTelno     (res.result.item.telno     ); // 전화번호
                setJbpsSeNm  (res.result.item.jbpsSeNm  ); // 직위코드명
                setJoinSttsCd(res.result.item.joinSttsCd); // 가입상태코드
                setJoinSttsNm(res.result.item.joinSttsNm); // 가입상태명
                setAtrzOpnnCn(res.result.item.atrzOpnnCn); // 결재의견(반려 사유)
                setCrtDt     (res.result.item.crtDt     ); // 가입일자
                setAuth01Yn(res.result.item.auth01Yn === "Y" ? true : false); // 조합비 관리자
                setAuth02Yn(res.result.item.auth02Yn === "Y" ? true : false); // 조합비 결재자
                setAuth03Yn(res.result.item.auth03Yn === "Y" ? true : false); // 조합비 조회
                setAuth04Yn(res.result.item.auth04Yn === "Y" ? true : false); // 조합원 관리자
                setAuth05Yn(res.result.item.auth05Yn === "Y" ? true : false); // 조합원 결재자
                setAuth06Yn(res.result.item.auth06Yn === "Y" ? true : false); // 조합원 조회
                setAuth07Yn(res.result.item.auth07Yn === "Y" ? true : false); // 본부 관리자
                setAuth08Yn(res.result.item.auth08Yn === "Y" ? true : false); // 시스템 관리자
                AppContext.hideSpinner();
            },
        });
    }, [userId]);

    // 회원정보 수정
    function saveUserInfo() {
        AppContext.openAlert({
            title: "회원정보 수정",
            msg: "회원정보를 수정하시겠습니까?",
            icon: "check",
            confirmText: "정보 수정",
            handleConfirm: () => {
                AppContext.showSpinner();
                Axios.dataAccess({
                    url: "system/mbr/mng/save-my-info.do",
                    methodType: "post",
                    paramType: "json",
                    paramData: {
                        userId: userId,
                        userNm: userNm, // 이름
                        telno : telno   // 전화번호
                    },
                    onSuccessFn: () => {
                        setMyInfoModalOpen(false);
                        AppContext.hideSpinner();
                        AppContext.openAlert({
                            title: "회원정보 수정 완료",
                            msg: "회원정보가 수정 완료되었습니다.",
                            icon: "check"
                        });
                        return;
                    }
                });
            }
        });
    }

    return (
        <div className="w600 bsBdb">
            <div className="p15 bd1d9d9d9 bdrd5 bgcWhite bsBdb">
                <div className="csP dpInBlock">
                    <div className="w120 h36 dpFlx aiC jcL h30">
                        <PersonIcon style={{ fontSize: 28, color: '#2882B7' }} />
                        <span className="Pretendard-Bold fs16 fc222222 ls075 taU fwB ml5">회원정보</span>
                    </div>
                </div>
                <div className="w100p">
                    <table className="w100p" style={{border: "1px solid #CECECE", borderCollapse: "collapse"}}>
                        <colgroup>
                            <col className='w15p'></col>
                            <col className='w35p'></col>
                            <col className='w15p'></col>
                            <col className='w35p'></col>
                        </colgroup>
                        <tbody>
                        <tr style={{height: "30px"}} >
                            <td className="pl10"><p className="fw700 fm-c fs14 fc2c3e50 taC">아이디</p></td>
                            <td>
                                <div className="dpFlx aiC jcC w180 bd1 h30 bdrd5 bdcDDDDDD bgcF1F8FF">
                                    <p className="fw700 fm-c fs14 fc2B2B2B taC">{userId}</p>
                                </div>
                            </td>
                            <td className="pl20"><p className="fw700 fm-c fs14 fc2c3e50 taC">이름</p></td>
                            <td>
                                <div className="dpFlx aiC jcC w180 bd1 h30 bdrd5 bdcDDDDDD bgcF1F8FF">
                                    <TextBox value={userNm}
                                        width={320} height={36}
                                        fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                        placeholder="성명을 입력하세요"
                                        style={{ backgroundColor: "#fff", padding: "0 12px" }}
                                        onChangeFunc={(data: string) => setUserNm(data)}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr style={{height: "30px"}} >
                            <td className="pl10"><p className="fw700 fm-c fs14 fc2c3e50 taC">본부</p></td>
                            <td>
                                <div className="dpFlx aiC jcC w180 bd1 h30 bdrd5 bdcDDDDDD bgcF1F8FF">
                                    <p className="fw700 fm-c fs14 fc2B2B2B taC">{upOgnzNm}</p>
                                </div>
                            </td>
                            <td className="pl20"><p className="fw700 fm-c fs14 fc2c3e50 taC">지부</p></td>
                            <td>
                                <div className="dpFlx aiC jcC w180 bd1 h30 bdrd5 bdcDDDDDD bgcF1F8FF">
                                    <p className="fw700 fm-c fs14 fc2B2B2B taC">{ognzNm}</p>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="pl10"><p className="fw700 fm-c fs14 fc2c3e50 taC">전화번호</p></td>
                            <td>
                                <div className="dpFlx aiC jcC w180 bd1 h30 bdrd5 bdcDDDDDD bgcF1F8FF">
                                    <TextBox value={Util.setPhoneNum(telno)}
                                        width={320} height={36}
                                        fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                        placeholder="전화번호를 입력하세요."
                                        style={{ backgroundColor: "#fff", padding: "0 12px" }}
                                        onChangeFunc={(data: string) => setTelno(data)}
                                    />
                                </div>
                            </td>
                            <td className="pl20"><p className="fw700 fm-c fs14 fc2c3e50 taC">직위</p></td>
                            <td>
                                <div className="dpFlx aiC jcC w180 bd1 h30 bdrd5 bdcDDDDDD bgcF1F8FF">
                                    <p className="fw700 fm-c fs14 fc2B2B2B taC">{jbpsSeNm}</p>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="pl10"><p className="fw700 fm-c fs14 fc2c3e50 taC">가입일자</p></td>
                            <td>
                                <div className="dpFlx aiC jcC w180 bd1 h30 bdrd5 bdcDDDDDD bgcF1F8FF">
                                    <p className="fw700 fm-c fs14 fc2B2B2B taC">{crtDt}</p>
                                </div>
                            </td>
                            <td className="pl20"><p className="fw700 fm-c fs14 fc2c3e50 taC">회원상태</p></td>
                            <td>
                                <div className="dpFlx aiC jcC w180 bd1 h30 bdrd5 bdcDDDDDD bgcF1F8FF">
                                    <p className="fw700 fm-c fs14 fc2B2B2B taC">{joinSttsNm}</p>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                {/* 권한 */}
                <div className="csP dpInBlock mt15">
                    <div className="w120 h36 dpFlx aiC jcL h30">
                        <GroupAddIcon style={{ fontSize: 28, color: '#2882B7' }} />
                        <span className="Pretendard-Bold fs16 fc222222 ls075 taU fwB ml5">회원 권한</span>
                    </div>
                </div>

                <div className="w100p">
                    <table className="w100p h110" style={{border: "1px solid #CECECE", borderCollapse: "collapse"}}>
                        <colgroup>
                            <col className='w35p'></col>
                            <col className='w35p'></col>
                            <col className='w30p'></col>
                        </colgroup>
                        <tbody>
                            <tr style={{height: "30px", borderBottom: "1px solid #CECECE"}} >
                                <td className="pl20">
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth01Yn}
                                            onChange={() => setAuth01Yn(!auth01Yn)}
                                            buttonColor='#2882B7'
                                            labelText='조합비 관리자'
                                            borderColor='#929191' borderOnColor='#929191'
                                            color='#000'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            disabled={true}
                                            textStyle={{ fontWeight: auth01Yn ? "bold" : "400" }}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth02Yn}
                                            onChange={() => setAuth02Yn(!auth02Yn)}
                                            buttonColor='#2882B7'
                                            labelText='조합비 결재자'
                                            borderColor='#929191' borderOnColor='#929191'
                                            color='#000'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            disabled={true}
                                            textStyle={{ fontWeight: auth02Yn ? "bold" : "400" }}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth03Yn}
                                            onChange={() => setAuth03Yn(!auth03Yn)}
                                            buttonColor='#2882B7'
                                            labelText='조합비 조회자'
                                            borderColor='#929191' borderOnColor='#929191'
                                            color='#000'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            disabled={true}
                                            textStyle={{ fontWeight: auth03Yn ? "bold" : "400" }}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr style={{height: "30px" , borderBottom: "1px solid #CECECE"}}>
                                <td className="pl20">
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth04Yn}
                                            onChange={() => setAuth04Yn(!auth04Yn)}
                                            buttonColor='#2882B7'
                                            labelText='조합원 관리자'
                                            borderColor='#929191' borderOnColor='#929191'
                                            color='#000'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            disabled={true}
                                            textStyle={{ fontWeight: auth04Yn ? "bold" : "400" }}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth05Yn}
                                            onChange={() => setAuth05Yn(!auth05Yn)}
                                            buttonColor='#2882B7'
                                            labelText='조합원 결재자'
                                            borderColor='#929191' borderOnColor='#929191'
                                            color='#000'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            disabled={true}
                                            textStyle={{ fontWeight: auth05Yn ? "bold" : "400" }}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth06Yn}
                                            onChange={() => setAuth06Yn(!auth06Yn)}
                                            buttonColor='#2882B7'
                                            labelText='조합원 조회자'
                                            borderColor='#929191' borderOnColor='#929191'
                                            color='#000'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            disabled={true}
                                            textStyle={{ fontWeight: auth06Yn ? "bold" : "400" }}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr style={{height: "30px"}}>
                                <td className="pl20">
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth07Yn}
                                            onChange={() => setAuth07Yn(!auth07Yn)}
                                            buttonColor='#2882B7'
                                            labelText='본부 관리자'
                                            borderColor='#929191' borderOnColor='#929191'
                                            color='#000'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            disabled={true}
                                            textStyle={{ fontWeight: auth07Yn ? "bold" : "400" }}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth08Yn}
                                            onChange={() => setAuth08Yn(!auth08Yn)}
                                            buttonColor='#2882B7'
                                            labelText='시스템 관리자'
                                            borderColor='#929191' borderOnColor='#929191'
                                            color='#000'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            disabled={true}
                                            textStyle={{ fontWeight: auth08Yn ? "bold" : "400" }}
                                        />
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* 반려 사유 표시 */}
                {joinSttsCd === "03" &&
                <>
                    <div className="csP dpInBlock mt15">
                        <div className="w120 h36 dpFlx aiC jcL h30">
                            <FeedbackIcon style={{ fontSize: 25, color: '#2882B7' }} />
                            <span className="Pretendard-Bold fs16 fc222222 ls075 taU fwB ml5">반려 사유</span>
                        </div>
                    </div>
                    <div className="dpFlx aiFs">
                        <div className="flxg1 bsBdb">
                            <textarea
                                value={atrzOpnnCn}
                                className="w100p h100 bsBdb p10 bd1 bdcDFDFDF bdrd2 fm-c fs14 fc333333 ls1 bgcWhite rszN"
                                maxLength={2000}
                                placeholder="반려 사유를 상세히 입력해주세요."
                                onChange={(e) => setAtrzOpnnCn(e.target.value)}
                                readOnly={true}
                            />
                        </div>
                    </div>
                </>
                }
            </div>

            {/* 사용승인, 사용정지 */}
            {(joinSttsCd === "02" || joinSttsCd === "05") && (
                <div className='w100p dpFlx aiC jcSb mt40 mb10'>
                    <div className="h40 dpFlx">
                        <div className="w100 aiC jcC bdrd5 bdBox csP dpFlx" style={{backgroundColor: "#bdc3c7"}} onClick={() => setMyInfoModalOpen(false)}>
                            <span className="fm-b fs15 fc222222">닫기</span>
                        </div>
                    </div>
                    <div className="h40 dpFlx">
                        <div className="w130 aiC jcC bdrd5 bdBox csP dpFlx ml10" style={{backgroundColor: "#6c757d"}} 
                        onClick={() => {
                            setMyInfoModalOpen(false);
                            setPswdModalOpen(true);
                        }}>
                            <span className="fm-b fs16 fcWhite">비밀번호 수정</span>
                        </div>
                        <div className="w130 aiC jcC bdrd5 bdBox csP dpFlx ml10" style={{backgroundColor: "#007bff"}} onClick={saveUserInfo}>
                            <span className="fm-b fs16 fcWhite">회원정보 수정</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default MyInfoDialog;